import { escapedRegex } from './escapedRegex.js'

export const filterDropdown = (options, searchTerm, suggestionsCount, addExactMatch) => {
    const exactMatch = addExactMatch ? options?.find(o => o.display.toLowerCase() === searchTerm.toLowerCase()) : null;

    let results = options?.filter(o => 
        (new RegExp(escapedRegex(searchTerm), 'i')).test(o.display) && o.display.toLowerCase() !== exactMatch?.display?.toLowerCase()
      );

    if (suggestionsCount) {
      results = results.slice(0, suggestionsCount);
    }

    if (addExactMatch) {
      if (exactMatch) {
        results.unshift(exactMatch);
      } else if (results.length > 0) {
        results.unshift({id: null, display: "No exact matching unit number"});
      }
    }
    
    return results;
}